import React from 'react';
import PropTypes from 'prop-types';

const PageTitle = (props) => (
    <div style={{
        "textAlign": "center",
        "fontSize" : "18px",
        "fontFamily" : "Lucida Grande, Lucida Sans Unicode, Arial, Helvetica, sans-serif"
    }}>
        <span>{ props.pageTitle }</span>
    </div>)

    PageTitle.propTypes = {
        pageTitle: PropTypes.string,
    }
export default PageTitle;
